import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatChannelMemberUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const channelMemberUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        member_attrs,
        user_id,
        ...rest
    } = extractProperties<NinchatChannelMemberUpdatedEvent>(action.payload)

    isEmpty(rest)

    state.user_channels[channel_id] ??= {channel_attrs: {}}
    const {channel_members = {}} = state.user_channels[channel_id]
    channel_members[user_id] ??= {}

    channel_members[user_id].member_attrs = member_attrs
}
